import { CommonFunctions } from '../static/common-functions';
import { QuoteService } from '../services/quote.service';
import { Subscription } from 'rxjs';
import { AttachmentBus } from "./AttachmentBus";
import { v_QuoteEquipmentBus } from './v_QuoteEquipmentBus';
import { BasePage } from './BasePage';
import { StatusHistoryBus } from './StatusHistoryBus';
import { v_DispatchLaborBus } from './v_DispatchLaborBus';
import { v_DispatchAttachmentBus } from './v_DispatchAttachmentBus';
import { DispatchesService } from '../services/dispatches.service';
import { v_DispatchAttachmentDetailBus } from './v_DispatchAttachmentDetailBus';

export class QuotePage extends BasePage<QuoteService>
{
    svc_data: QuoteService;
    constructor(svc_data: QuoteService, private svc_disp: DispatchesService, data: QuotePage = null)
  {
      super();
    this.svc_data = svc_data;
    if (data !== null) {
//      this.dispatchId = data.dispatchId;
    }
  }

 clear() {
     this.unsubscribe();
     this.id = null;
     this.statusHistory = null;
     this.dispatchLabor = null;
     this.quoteEquipment = null;
     this.attachments = null;
     this.dispatchAttachments = null;
     this.dispatchImages = null
     this.statusHistoryLoading = false;
     this.dispatchLaborLoading = false;
     this.quoteEquipmentLoading = false;
     this.attachmentsLoading = false;
     this.dispatchAttachmentsLoading = false;
     this.dispatchImagesLoading = false;
 }
  unsubscribe() {
    CommonFunctions.unsubscribe(this.subs_statusHistory);
    CommonFunctions.unsubscribe(this.subs_dispatchLabor);
    CommonFunctions.unsubscribe(this.subs_quoteEquipment);
    CommonFunctions.unsubscribe(this.subs_attachments);
    CommonFunctions.unsubscribe(this.subs_dispatchAttachments);
      CommonFunctions.unsubscribe(this.subs_dispatchImages);
  }

  subs_attachments: Subscription;
  subs_quoteEquipment: Subscription;
  subs_statusHistory: Subscription;
  subs_dispatchLabor: Subscription;
  subs_dispatchAttachments: Subscription;
  subs_dispatchImages: Subscription;

    setAttachments(data: AttachmentBus[]) {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: AttachmentBus = new AttachmentBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.attachments = arr;
    }
    getAttachments(id: any) {
        if (!CommonFunctions.hasValue(id)) {
            return;
        }
        this.attachmentsLoading = true;
        CommonFunctions.unsubscribe(this.subs_attachments);
        this.subs_attachments = this.svc_data.getAttachments(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: AttachmentBus = new AttachmentBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.attachments = arr;
            this.attachmentsLoading = false;
        });
    }
    getQuoteEquipment(id: any) {
        this.quoteEquipmentLoading = true;
        CommonFunctions.unsubscribe(this.subs_quoteEquipment);
        this.subs_quoteEquipment = this.svc_data.getQuoteEquipment(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: v_QuoteEquipmentBus = new v_QuoteEquipmentBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.quoteEquipment = arr;
            this.quoteEquipmentLoading = false;
        });
    }
    getStatusHistory(id: any) {
        this.statusHistoryLoading = true;
        CommonFunctions.unsubscribe(this.subs_statusHistory);
        this.subs_statusHistory = this.svc_data.getQuoteStatusHistory(id).subscribe(data => {
            this.statusHistory = data;
            this.statusHistoryLoading = false;
        });
    }
    getDispatchAttachments(id: any) {
        this.dispatchAttachmentsLoading = true;
        CommonFunctions.unsubscribe(this.subs_attachments);
        this.subs_attachments = this.svc_disp.GetDocs(id).subscribe(data => {
            this.dispatchAttachments = data;
            this.dispatchAttachmentsLoading = false;
        });
    };
    getDispatchImages(id: any) {
        this.dispatchImagesLoading = true;
        CommonFunctions.unsubscribe(this.subs_dispatchImages);
        this.subs_dispatchImages = this.svc_disp.GetImages(id).subscribe(data => {
            this.dispatchImages = data;
            this.dispatchImagesLoading = false;
        });
    };
    getDispatchLabor(id: any) {
        this.dispatchLaborLoading = true;
        CommonFunctions.unsubscribe(this.subs_dispatchLabor);
        this.subs_dispatchLabor = this.svc_disp.GetDispatchLabor(id).subscribe(data => {
            this.dispatchLabor = data;
            this.dispatchLaborLoading = false;
        });
    };

  id: any;
  attachments: AttachmentBus[];
  quoteEquipment: v_QuoteEquipmentBus[];
  statusHistory: StatusHistoryBus[];
  dispatchAttachments: v_DispatchAttachmentBus[];
  dispatchLabor: v_DispatchLaborBus[];
  dispatchImages: v_DispatchAttachmentDetailBus[];

    attachmentsLoading: boolean = false;
    quoteEquipmentLoading: boolean = false;
    statusHistoryLoading: boolean = false;
    dispatchAttachmentsLoading: boolean = false;
    dispatchLaborLoading: boolean = false;
    dispatchImagesLoading: boolean = false;

  get hasAttachments(): boolean {
    return CommonFunctions.hasValue(this.attachments) || this.attachmentsLoading;
  }
  get hasQuoteEquipment(): boolean {
        return CommonFunctions.hasValue(this.quoteEquipment) || this.quoteEquipmentLoading;
  }
    get hasStatusHistory(): boolean {
        return CommonFunctions.hasValue(this.statusHistory) || this.statusHistoryLoading;
    }
    get hasDispatchAttachments(): boolean {
        return CommonFunctions.hasValue(this.dispatchAttachments) || this.dispatchAttachmentsLoading;
    }
    get hasDispatchLabor(): boolean {
        return CommonFunctions.hasValue(this.dispatchLabor) || this.dispatchLaborLoading;
    }
    get hasDispatchImages(): boolean {
        return CommonFunctions.hasValue(this.dispatchImages) || this.dispatchImagesLoading;
    }
}
